export default __webpack_public_path__ + "static/media/advantages__item-icon-4.587e2241.svg";